// frontend/customer-portal/src/components/UsageMeter.jsx
import React from 'react';

/**
 * UsageMeter — shows a progress bar with current/max usage.
 *
 * Props:
 *   label: string — e.g. "Users"
 *   current: number
 *   max: number | null — null = unlimited (shows no bar)
 *   className: string (optional)
 */
export default function UsageMeter({ label, current, max, className = '' }) {
  if (max === null || max === undefined) {
    return (
      <div className={`flex items-center gap-2 text-sm text-gray-600 ${className}`}>
        <span className="font-medium">{label}:</span>
        <span>{current} / Unlimited</span>
      </div>
    );
  }

  const pct = max > 0 ? Math.min((current / max) * 100, 100) : 0;
  const isRed = current >= max;
  const isAmber = !isRed && pct >= 80;
  const barColor = isRed ? 'bg-red-500' : isAmber ? 'bg-amber-400' : 'bg-green-500';
  const textColor = isRed ? 'text-red-600' : isAmber ? 'text-amber-600' : 'text-gray-600';

  return (
    <div className={`${className}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium text-gray-700">{label}</span>
        <span className={`text-sm font-semibold ${textColor}`}>
          {current} / {max}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`${barColor} h-2 rounded-full transition-all`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
